module.exports = __webpack_public_path__ + "img/youtube-brands.2db8532a.svg";